export default __webpack_public_path__ + "img/5a594ebd610150fe147d3ce62505f409.svg";